var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 190",
    enableBackground: "new 0 0 190 190",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 295.5,
    cy: 55.25,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 71.501,
    cy: 55.25,
    r: 77.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Instructions_and_Tone"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EAEAEA",
    cx: 108.625,
    cy: 100.863,
    r: 77.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000050642051515909605750000002460655021961268398_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#99C2FD",
    d: "M175.996,24.78c-2.635-2.043-6.373-1.548-9.639-0.878c-8.63,1.763-17.135,2.355-25.003,6.365 c-5.736,2.922-12.159,4.065-18.396,5.396c-4.352,0.929-14.11,1.423-14.279,7.47c-0.073,2.596,1.375,4.983,2.984,7.021 c2.178,2.761,4.75,5.21,7.613,7.252c2.061,1.471,4.293,2.748,6.044,4.576c4.965,5.183-7.999,13.296-10.945,16.54 c-4.503,4.958-8.614,10.227-13.287,15.041c-1.32,1.359-8.587,10.267-10.423,10.734c-1.944,0.495-3.991-0.206-5.776-1.122 c-9.788-5.02-18.779-17.03-28.852-12.611c-6.618,2.902-9.689,9.604-13.812,15.11c-4.683,6.253-17.89,17.855-22.444,24.206 c-3.338,4.655-5.836,10.279-9.438,14.613c-3.564,4.288-7.813,7.807-5.615,14.165c1.154,3.332,4.122,5.972,7.567,6.727 c6.794,1.489,11.658-3.835,15.06-8.811c3.951-5.777,8.042-11.459,12.269-17.036c3.599-4.749,16.81-19.793,21.953-22.784 c4.286-2.493,9.604,2.389,13.012,4.523c5.501,3.443,11.055,6.807,16.655,10.088c3.554,2.081,9.149,3.166,12.915,0.719 c1.403-0.911,2.366-2.346,3.287-3.743c5.325-8.09,20.641-25.688,25.699-33.946c3.597-5.873,7.743-15.7,16.038-15.976 c5.746-0.19,9.352,5.828,12.647,10.539s10.141,8.959,14.265,4.953c2.097-2.038,2.27-5.292,2.307-8.215 c0.219-16.92,0.438-33.84,0.657-50.76C179.107,31.263,178.9,27.031,175.996,24.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M88.126,169.339c-17.878,0-34.728-5.841-48.731-16.891c-1.062-0.837-1.243-2.376-0.406-3.438 c0.838-1.061,2.377-1.242,3.438-0.404c13.131,10.36,28.933,15.838,45.699,15.838c36.645,0,68.081-27.325,73.124-63.561 c0.185-1.339,1.43-2.275,2.761-2.087c1.339,0.187,2.274,1.423,2.087,2.763C160.721,140.202,127.2,169.339,88.126,169.339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M16.914,120.458c-0.983,0-1.911-0.598-2.285-1.569c-3.47-9.017-5.23-18.529-5.23-28.274 c0-43.411,35.316-78.728,78.727-78.728c14.929,0,29.459,4.198,42.019,12.139c1.143,0.723,1.483,2.234,0.761,3.377 c-0.723,1.142-2.232,1.484-3.377,0.761c-11.776-7.446-25.401-11.382-39.403-11.382c-40.711,0-73.832,33.121-73.832,73.833 c0,9.142,1.65,18.063,4.903,26.516c0.485,1.262-0.143,2.678-1.404,3.164C17.503,120.404,17.206,120.458,16.914,120.458"
  })))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_02_Productivity.9dd5660c.svg";
export { SvgComponent as ReactComponent };